import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 9,
	viewBox: "0 0 14 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: 1.16675,
		width: 1.64991,
		height: 9.89944,
		transform: "rotate(-45 0 1.16675)",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 12.8334,
		width: 1.64991,
		height: 9.89944,
		transform: "rotate(45 12.8334 0)",
		fill: "currentColor"
	})]
});
export default SvgDownArrow;
